import { getCurrentUserId } from '@/state/auth-state';
import { aiService } from './ai';
import { analyticsService } from './analytics';
import { createApiService } from './api';
import { supabaseClient } from './api/supabase';
import { localStorageService } from './local-storage';

export const appServices = {
  api: createApiService(supabaseClient, getCurrentUserId),
  localStorage: localStorageService,
  analytics: analyticsService,
  ai: aiService,
};
